export enum AgendaEventType {
  CheckIn = 'Check in',
  CheckOut = 'Check out',
}
